module.exports = __webpack_public_path__ + "img/step45_down.319be2cf.png";